import { store } from 'store/configureStore';

import { setAuthTokenAccess, setAuthTokenRefresh, setAuthTokenWellFunnel } from './actions';

import { AUTH_TOKEN_REFRESH_NAME, AUTH_TOKEN_NAME, AUTH_TOKEN_WELLFUNNEL_NAME } from 'constants/api';

import { deleteCookie, setCookie } from 'helpers/cookie';

export const setTokenAccessOperation = (token: string) => {
    setCookie(AUTH_TOKEN_NAME, token);
    store.dispatch(setAuthTokenAccess(token));
};

export const setTokenRefreshOperation = (token: string) => {
    setCookie(AUTH_TOKEN_REFRESH_NAME, token);
    store.dispatch(setAuthTokenRefresh(token));
};

export const setTokenWellFunnelOperation = (token: string) => {
    setCookie(AUTH_TOKEN_WELLFUNNEL_NAME, token);
    store.dispatch(setAuthTokenWellFunnel(token));
};

export const deleteTokensOperation = () => {
    deleteCookie(AUTH_TOKEN_NAME);
    deleteCookie(AUTH_TOKEN_WELLFUNNEL_NAME);
    deleteCookie(AUTH_TOKEN_REFRESH_NAME);
    store.dispatch(setAuthTokenAccess(null));
    store.dispatch(setAuthTokenWellFunnel(null));
    store.dispatch(setAuthTokenRefresh(null));
};
